export default function NotificationsController() {}
